<template>
  <div>
    <DxPopup
      :visible="popupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      :width="975"
      :height="750"
      title="Almondco Despatch Data"
      @hidden="popupHidden"
      :showCloseButton="false"
    >
      <div>
        <div class="header-form">
          <gc-form
            :formOptions="formOptions"
            :formItems="formItems"
            :formHeight="'auto'"
            :isNormal="true"
            :data-model="dataModel"
            :formMode="baseView.mode"
            :validationGroup="'gc-popup-form-data'"
            :formTitle="'gc-popup'"
            v-if="formItems"
            :checkValid="isValid"
            :ref="'almondco-despatch-data-form'"
          ></gc-form>
        </div>

        <GcDataGrid
          :grouping="false"
          :export="false"
          :summary="false"
          :paging="true"
          :dataSourceConfig="dataSourceConfig"
          :columns="columns"
          :gridToolbar="gridToolbar"
          :padColumn="false"
          :id="'grid-report-grid'"
          :auto-expand-all="false"
          :gridOptions="gridOptions"
          :gridHeightOverWrite="470"
          :isLocalDataSource="true"
          :valueChangeListners="getListners"
          :ref="'almondco-despatch-data'"
          :dxScrolling="'standard'"
          :rowRemoved="rowRemoved"
          :isEditableGrid="true"
          :key="gridKey"
          :keyExpr="keyExpr"
        />

        <div class="footer-form">
          <gc-form
            :formOptions="formOptions"
            :formItems="footerFormItems"
            :formHeight="'auto'"
            :isNormal="true"
            :data-model="dataModel"
            :formMode="baseView.mode"
            :validationGroup="'gc-popup-form-data'"
            :formTitle="'gc-popup'"
            v-if="formItems"
            :checkValid="isValidFooter"
          ></gc-form>
        </div>

        <div class="footer">
          <DxButton
            class="save-btn"
            text="Save"
            type="default"
            styling-mode="contained"
            @click="saveData"
            :disabled="getDisabledSave"
          />
          <DxButton
            text="Cancel"
            type="default"
            styling-mode="contained"
            @click="popupHidden"
          />
        </div>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { ProductService } from "../_services/api/products/product.service";
import { AlmondcoDespatchDataService } from "../_services/api/sales/almondco-despatch-data.service";
import { ProductBatchService } from "../_services/api/inventory/product-batch.service";

export default {
  props: {
    setVisible: Boolean,
    almondcoDespatchData: {
      type: Object,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: function () {},
    },
    showValidationSummary: {
      type: Function,
      default: function () {},
    },
  },
  mixins: [RouteMixin, FormMixin],
  data() {
    return {
      keyExpr: "rowKey",
      formOptions: {
        gcLabelLocation: "left",
      },
      dataModel: {
        CartonSize: undefined,
        CartonSizeUM: undefined,
        PickedWeight: 0,
        DespatchedWeight: 0,
        ProductCode: undefined,
        ProductDisplay: undefined,
      },
      isValid: false,
      isValidFooter: false,
      loaded: false,

      disabledSave: true,
      localItems: [],
      gridKey: 0,
      loadItems: false,
      validationSummary: [],
      visibleAddNew: true,
    };
  },
  async created() {
    this.setLoading(true);
    if (this.almondcoDespatchData.type == "delivery-note") {
      if (this.almondcoDespatchData.model.Status != "Pending")
        this.visibleAddNew = false;

      await AlmondcoDespatchDataService.getFromPickingSlip(
        this.almondcoDespatchData.model.SalesOrderNo,
        this.almondcoDespatchData.data.ItemCode
      ).then((res) => {
        this.almondcoDespatchData.data.StockUMSuppliedQty =
          res.data.value[0].StockUMSuppliedQty;
      });

      this.dataModel.CartonSize = this.almondcoDespatchData.data.CartonSize;

      await AlmondcoDespatchDataService.dataSourceConfigQCData(
        this.almondcoDespatchData.data.DeliveryNote,
        this.almondcoDespatchData.data.LineNo
      ).then((res) => {
        this.localItems = res.data.value;
        if (res.data.value.length > 0) this.loadItems = true;
        this.localItems.forEach((element) => {
          if (element.DespatchDate)
            element.DispatchDate = new Date(
              element.DespatchDate.replace("Z", "")
            );
          if (element.PackedOnDate)
            element.PackedOnDate = new Date(
              element.PackedOnDate.replace("Z", "")
            );

          element.LotSequenceNo = element.PalletNo;
          element.CartonQuantity = element.CartonQty;
        });

        this.localItems = this.postProcessCallback(this.localItems);
      });
    } else {
      await AlmondcoDespatchDataService.getLotAssignment(
        this.almondcoDespatchData.data.SalesOrderCode,
        this.almondcoDespatchData.data.ItemCode
      ).then((res) => {
        if (res.data.value.length > 0) this.loadItems = true;
      });

      if (this.loadItems)
        await AlmondcoDespatchDataService.dataSourceConfig(
          this.almondcoDespatchData.data.SalesOrderCode,
          this.almondcoDespatchData.data.LineNo
        ).then((res) => {
          this.localItems = res.data.value;

          this.localItems.forEach((element) => {
            element.DispatchDate = new Date(
              element.DispatchDate.replace("Z", "")
            );
            element.PackedOnDate = new Date(
              element.PackedOnDate.replace("Z", "")
            );
          });

          if (res.data.value.length == 0) this.loadItems = false;
        });

      await ProductService.getByCode(
        this.almondcoDespatchData.data.ItemCode
      ).then((res) => {
        this.dataModel.CartonSize = res.data.value[0].PackSize;
      });

      this.localItems = this.postProcessCallback(this.localItems);
    }

    this.dataModel.ItemCode = this.almondcoDespatchData.data.ItemCode;
    this.dataModel.ItemDescription =
      this.almondcoDespatchData.data.ItemDescription;
    this.dataModel.ProductCode = this.almondcoDespatchData.data.ItemCode;
    this.dataModel.PickedWeight =
      this.almondcoDespatchData.data.StockUMSuppliedQty;

    if (this.almondcoDespatchData.data.Product) {
      this.dataModel.ProductDisplay =
        this.almondcoDespatchData.data.ProductCode +
        " - " +
        this.almondcoDespatchData.data.ProductDescription;
    } else
      this.dataModel.ProductDisplay =
        this.almondcoDespatchData.data.ItemCode +
        " - " +
        this.almondcoDespatchData.data.ItemDescription;
    this.loaded = true;
    this.gridKey++;

    if (
      this.dataModel.PickedWeight == this.dataModel.DespatchedWeight &&
      this.dataModel.DespatchedWeight != 0
    )
      this.disabledSave = false;
    else this.disabledSave = true;

    if (this.almondcoDespatchData.data.AlmondcoWriteDespatchData) {
      if (
        this.almondcoDespatchData.data.AlmondcoWriteDespatchData
          .AlmondcoWriteDespatchDataDetails &&
        this.almondcoDespatchData.data.AlmondcoWriteDespatchData
          .AlmondcoWriteDespatchDataDetails.length > 0
      ) {
        this.almondcoDespatchData.data.AlmondcoWriteDespatchData.AlmondcoWriteDespatchDataDetails.forEach(
          (item) => {
            this.localItems.push({
              DispatchDate: new Date(item.DespatchDate),
              PackedOnDate: new Date(item.PackedOnDate),
              LotNo: item.LotNo,
              LotSequenceNo: item.PalletNo,
              WorkOrder: item.WorkOrderNo,
              CartonWeight: item.CartonWeight,
              CartonQuantity: item.CartonQuantity,
              DespatchWeight: item.TotalWeight,
              PickedWeight: item.PickedWeight,
              RecordId: item.RecordId,
              SalesOrderLine: this.almondcoDespatchData.data.LineNo,
              SalesOrderNo: this.almondcoDespatchData.data.SalesOrderCode,
              isNew: true,
            });
          }
        );
      }
    }

    if (!this.loadItems && this.localItems.length == 0) {
      this.localItems.push({
        CartonQuantity: 0,
        CartonWeight: 0,
        DispatchDate: new Date(),
        LotNo: undefined,
        LotSequenceNo: undefined,
        PackedOnDate: undefined,
        SalesOrderLine: this.almondcoDespatchData.data.LineNo,
        SalesOrderNo: this.almondcoDespatchData.data.SalesOrderCode,
        TotalWeight: 0,
        WorkOrder: undefined,
        DespatchWeight: 0 * this.dataModel.CartonSize,
        isNew: true,
      });
    }
    this.setLoading(false);
  },
  computed: {
    gridOptions() {
      return {
        options: {
          onEditorPreparing: this.onEditorPreparing,
          onContentReadyCallBack: this.onContentReadyCallBack,
        },
      };
    },
    getDisabledSave() {
      if (this.almondcoDespatchData.model.Status == "Invoiced") return true;
      else return this.disabledSave;
    },
    getListners() {
      return [
        {
          dataField: "DispatchDate",
          listner: (e, lineData) => {
            lineData.data.DispatchDate = e.value;
          },
        },
        {
          dataField: "PackedOnDate",
          listner: (e, lineData) => {
            lineData.data.PackedOnDate = e.value;
          },
        },
        {
          dataField: "WorkOrder",
          listner: (e, lineData) => {
            lineData.data.WorkOrder = e.itemData.WorkOrderNoComputedString;
          },
        },
        {
          dataField: "ActionDelete",
          listner: (e, lineData) => {
            this.deleteRow(e, lineData);
          },
        },
        {
          dataField: "ActionAddNew",
          listner: (e, lineData) => {
            this.addNewRow(e, lineData);
          },
        },
        {
          dataField: "CartonQuantity",
          listner: (e, lineData) => {
            this.onCartonQuantityChange(e, lineData);
          },
        },
        {
          dataField: "LotNo",
          listner: (e, lineData) => {
            lineData.data.LotNo = e.value;
          },
        },
        {
          dataField: "LotSequenceNo",
          listner: (e, lineData) => {
            lineData.data.LotSequenceNo = e.value;
          },
        },
      ];
    },
    dataSourceConfig() {
      return {
        localDataList: true,
        items: this.localItems,
        serverPaging: true,
        allowGrouping: false,
        postProcessCallback: this.postProcessCallback,
      };
    },
    gridToolbar() {
      return {
        search: false,
        columnChooser: false,
        export: false,
        openFilter: false,
        header: false,
      };
    },
    popupVisible() {
      return this.setVisible ? true : false;
    },
    formItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  // screenField: "Product",
                  dataField: "ProductDisplay",
                  label: {
                    text: "Product",
                  },
                  editorType: "dxTextBox",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
                {
                  // screenField: "Supplier",
                  dataField: "CartonSize",
                  editorType: "dxNumberBox",
                  label: {
                    text: "Carton Size",
                  },
                  cssClass: "a-des-d-carton-size",
                  editorOptions: {
                    readOnly: true,
                    customFormat: true,
                    format: `##,###,###,###,##0.00 ${this.almondcoDespatchData.data.StockUM}`,
                    tabIndex: -1,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    footerFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              // screenField: "ReceivedQty",
              dataField: "PickedWeight",
              editorOptions: {
                readOnly: true,
                customFormat: true,
                format: `##,###,###,###,##0.0000 ${this.almondcoDespatchData.data.StockUM}`,
                tabIndex: -1,
              },
              label: {
                text: "Picked Weight",
              },
            },
            {
              // screenField: "ReceivedQty",
              dataField: "DespatchedWeight",
              label: {
                text: "Despatched Weight",
              },
              editorOptions: {
                readOnly: true,
                customFormat: true,
                format: `##,###,###,###,##0.0000 ${this.almondcoDespatchData.data.StockUM}`,
                // readOnly: true,
                onValueChanged: (e) => {
                  if (e) {
                    this.onDespatchedWeightChange(e);
                  }
                },
                allowUpdate: true,
                tabIndex: -1,
              },
            },
          ],
        },
      ];
    },
    columns() {
      return [
        {
          screenField: "Date",
          gridDataField: "DispatchDate",
          label: "Despatch Date",
          filterIndex: 0,
          editable: true,
          cellTemplate: "Date",
          minWidth: 120,
          makeReadOnly: (data) => {
            if (data.data.isNew) return false;
            else return true;
          },
        },
        {
          screenField: "Date",
          gridDataField: "PackedOnDate",
          label: "Packed On Date",
          editable: true,
          cellTemplate: "Date",
          minWidth: 120,
          makeReadOnly: (data) => {
            if (data.data.isNew) return false;
            else return true;
          },
          editorOptions: {
            max: new Date(),
          },
        },
        {
          screenField: "WorkOrder",
          allowEditing: true,
          allowUpdate: true,
          showEditorAlways: true,
          validationRules: [
            {
              type: "required",
              message: "Work Order is required",
            },
          ],
          cssClass: "gc-editable-field-underline",
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProductBatchService.dataSourceConfig("api/WorklogAll", {
              sort: {
                selector: "WorkOrderNo",
                desc: true,
              },
              select: [
                "WorkOrderNo",
                "BillNo",
                "BomDescription",
                "CustomerName",
                "WorkOrderNoComputedString",
              ],
            }),
            displayExpr: "WorkOrderNoComputedString",
            valueExpr: "WorkOrderNo",
            searchExpr: [
              "WorkOrderNoComputedString",
              "BillNo",
              "BomDescription",
            ],
            searchMode: "contains",
            searchEnabled: true,
            // showClearButton: true,
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.WorkOrderNo}" >
                <span class="auto-complete-primary">
                  ${data.WorkOrderNo}
                </span> <br />
                <span class="record-secondary gc-grid-code">
                  ${data.BillNo} <br />
                  ${data.BomDescription}<br />
                  ${data.CustomerName}
                </span>
              </div>`;
            },
            dropDownOptions: {
              width: 300,
            },
            onFocusOut: (e) => {
              if (e) {
                const invalidMessageElement = document.querySelector(
                  ".dx-datagrid-content .dx-overlay-wrapper.dx-invalid-message.dx-datagrid-invalid-message"
                );
                if (invalidMessageElement) {
                  invalidMessageElement.style.visibility = "hidden";
                }
              }
            },
          },
          width: 120,
          setCellValue: (newData, value) => {
            newData.WorkOrder = value;

            return newData;
          },
        },
        {
          screenField: "SalesOrderLine",
          gridDataField: "LotNo",
          label: "Lot No",
          width: 120,

          type: "EditableDecimal",
          format: "Decimal-16-0",
          showEditorAlways: true,
          allowSearch: false,
          // allowSorting: false,
          allowFiltering: false,
          minmax: { max: 999999.0 },
          makeReadOnly: (data) => {
            if (data.data.isNew) return false;
            else return true;
          },
          allowUpdate: true,
        },
        {
          screenField: "SalesOrderLine",
          gridDataField: "LotSequenceNo",
          label: "Pallet No",
          width: 120,

          type: "EditableDecimal",
          format: "Decimal-16-0",
          showEditorAlways: true,
          allowSearch: false,
          // allowSorting: false,
          allowFiltering: false,
          minmax: { max: 999999.0 },
          makeReadOnly: (data) => {
            if (data.data.isNew) return false;
            else return true;
          },
          allowUpdate: true,
        },
        {
          screenField: "ReceivedQty",
          gridDataField: "CartonQuantity",
          label: "Carton Quantity",
          width: 120,

          type: "EditableDecimal",
          format: "Decimal-16-2",
          showEditorAlways: true,
          allowSearch: false,
          // allowSorting: false,
          allowFiltering: false,
          minmax: { max: 999999.0 },
          makeReadOnly: (data) => {
            if (data.data.isNew) return false;
            else return true;
          },
          allowUpdate: true,
        },
        {
          screenField: "ReceivedQty",
          gridDataField: "DespatchWeight",
          label: "Despatch Weight",
          width: 120,
        },
        {
          dataField: "ActionDelete",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionDelete",
          visible: this.visibleAddNew,
        },
        {
          dataField: "ActionAddNew",
          label: "",
          width: 50,
          minWidth: 50,
          cellTemplate: "ActionAddNew",
          visible: this.visibleAddNew,
        },
      ];
    },
  },
  watch: {},
  methods: {
    onContentReadyCallBack(e) {
      if (e && this.localItems.length > 0) {
        let index = this.localItems.findIndex((x) => x.isNew);
        if (index != -1) {
          let gridInstance =
            this.$refs["almondco-despatch-data"].getGridInstance();
          if (gridInstance) {
            let cellElement = gridInstance.getCellElement(
              index,
              "DispatchDate"
            );
            if (cellElement) {
              gridInstance.focus(cellElement);
            }
          }
        }
      }

      if (e) {
        const pagerElement = e.element.querySelectorAll(".dx-page-size");
        pagerElement.forEach((element) => {
          element.setAttribute("tabindex", "-1");
        });

        const pageNumbers = e.element.querySelectorAll(".dx-page.dx-selection");

        pageNumbers.forEach((element) => {
          element.setAttribute("tabindex", "-1");
        });
      }
    },
    onEditorPreparing(e) {
      if (e.dataField == "WorkOrder") {
        if (!e.row.data.isNew) {
          // e.readOnly = true;
          // e.allowEditing = false;
          // e.lookup = undefined;
          // e.showEditorAlways = false;
          // e.editorType = undefined;
          // // e.editorOptions.disabled = true;
          e.editorOptions.readOnly = true;
          e.editorElement.classList.add("dx-state-readonly");
        }
      }
    },
    onCartonQuantityChange(e, lineData) {
      lineData.data.CartonQuantity = e.value;
      this.dataModel.DespatchedWeight =
        this.dataModel.DespatchedWeight - lineData.data.DespatchWeight;
      lineData.data.DespatchWeight = e.value * this.dataModel.CartonSize;
      // lineData.data.DespatchWeight = parseFloat(e.value * this.dataModel.CartonSize).toFixed(2);
      // lineData.data.DespatchWeight = parseFloat((lineData.data.DespatchWeight).toFixed(2));
      this.dataModel.DespatchedWeight =
        this.dataModel.DespatchedWeight + lineData.data.DespatchWeight;

      this.$refs["almondco-despatch-data"].gridRepaint();

      this.onDespatchedWeightChange({ e: this.dataModel.DespatchedWeight });
    },
    onDespatchedWeightChange(e) {
      if (this.dataModel.PickedWeight == e.value && e.value > 0)
        this.disabledSave = false;
      else this.disabledSave = true;
    },
    rowRemoved(e) {
      this.dataModel.DespatchedWeight =
        this.dataModel.DespatchedWeight - e.data.DespatchWeight;

      if (this.localItems.length == 0) {
        this.localItems.push({
          CartonQuantity: 0,
          CartonWeight: 0,
          DispatchDate: new Date(),
          LotNo: undefined,
          LotSequenceNo: undefined,
          PackedOnDate: undefined,
          SalesOrderLine: this.almondcoDespatchData.data.LineNo,
          SalesOrderNo: this.almondcoDespatchData.data.SalesOrderCode,
          TotalWeight: 0,
          WorkOrder: undefined,
          DespatchWeight: 0 * this.dataModel.CartonSize,
          isNew: true,
        });
      }
    },
    async addNewRow(e, lineData) {
      if (!e) return;
      this.validationSummary = [];
      if (!lineData.data.PackedOnDate && lineData.data.isNew)
        this.validationSummary.push({
          message: "Packed On Date is required",
        });
      else if (!lineData.data.WorkOrder && lineData.data.isNew)
        this.validationSummary.push({
          message: "Work Order is required",
        });

      if (this.validationSummary.length > 0)
        this.showValidationSummary(this.validationSummary);
      else {
        this.setLoading(true);

        let rowKey = this.localItems.length + 1;
        this.localItems.splice(lineData.rowIndex + 1, 0, {
          CartonQuantity: 0,
          CartonWeight: 0,
          DispatchDate: new Date(),
          LotNo: undefined,
          LotSequenceNo: undefined,
          PackedOnDate: undefined,
          SalesOrderLine: this.almondcoDespatchData.data.LineNo,
          SalesOrderNo: this.almondcoDespatchData.data.SalesOrderCode,
          TotalWeight: 0,
          WorkOrder: undefined,
          DespatchWeight: 0 * this.dataModel.CartonSize,
          isNew: true,
          rowKey: rowKey,
        });
        this.setLoading(false);
        this.$refs["almondco-despatch-data"].gridRepaint();
        setTimeout(() => {
          let index = this.localItems.length - 1;
          if (index != -1) {
            let gridInstance =
              this.$refs["almondco-despatch-data"].getGridInstance();
            if (gridInstance) {
              let cellElement = gridInstance.getCellElement(
                index,
                "DispatchDate"
              );
              if (cellElement) {
                gridInstance.focus(cellElement);
              }
            }
          }
        }, 250);
      }
    },
    async deleteRow(e, lineData) {
      if (!e) return;
      var gridInstance = this.$refs["almondco-despatch-data"].getGridInstance();
      gridInstance.deleteRow(lineData.rowIndex);
    },
    postProcessCallback(data) {
      let despatchedWeight = 0;
      let rowKey = 0;
      data.forEach((element) => {
        if (element.isNew == undefined) element.isNew = false;

        element.DespatchWeight =
          element.CartonQuantity * this.dataModel.CartonSize;

        despatchedWeight = (
          despatchedWeight + element.DespatchWeight
        ).roundNumber(2);

        if (this.almondcoDespatchData.model.Status == "Pending") {
          // if(element.WorkOrder == 0 )element.WorkOrderNoComputedString = undefined
          // else element.WorkOrderNoComputedString = element.WorkOrder;
          element.isNew = true;
          // element.WorkOrder = element.WorkOrder.toString();
        }
        element.rowKey = ++rowKey;
      });

      this.dataModel.DespatchedWeight = despatchedWeight;

      if (
        this.dataModel.PickedWeight == this.dataModel.DespatchedWeight &&
        this.dataModel.DespatchedWeight > 0
      )
        this.disabledSave = false;

      return data;
    },
    // formCallBack(e) {
    //   console.log("formCallBack ", e);
    // },
    popupHidden() {
      this.almondcoDespatchData.popUpCallBack();
    },
    async saveData() {
      this.validationSummary = [];

      this.localItems.forEach((element) => {
        if (!element.PackedOnDate && element.isNew) {
          this.validationSummary.push({
            message: "Packed On Date is required",
          });
        } else if (!element.WorkOrder && element.isNew)
          this.validationSummary.push({
            message: "Work Order is required",
          });
      });

      if (this.validationSummary.length > 0) {
        this.showValidationSummary(this.validationSummary);
      } else {
        this.setLoading(true);
        if (this.almondcoDespatchData.type == "delivery-note") {
          let payload = {
            DeliveryNote: this.almondcoDespatchData.data.DeliveryNote,
            DeliveryNoteLineNo: this.almondcoDespatchData.data.LineNo,
            ItemCode: this.almondcoDespatchData.data.ItemCode,
            ItemDescription: this.almondcoDespatchData.data.ItemDescription,
            RecordId: "00000000-0000-0000-0000-000000000000",
            AlmondcoWriteDespatchDataDetails: this.localItems.map((item) => {
              return {
                DespatchDate: item.DispatchDate.toSaveDate(),
                PackedOnDate: item.PackedOnDate.toSaveDate(),
                LotNo: item.LotNo,
                PalletNo: item.LotSequenceNo,
                WorkOrderNo: item.WorkOrder,
                CartonWeight: item.CartonWeight,
                CartonQuantity: item.CartonQuantity,
                TotalWeight: item.DespatchWeight,
                PickedWeight: this.dataModel.PickedWeight,
                RecordId: "00000000-0000-0000-0000-000000000000",
              };
            }),
          };

          await AlmondcoDespatchDataService.SaveAlmondcoWriteDespatchData(
            payload
          )
            .then((res) => {
              if (res) this.setLoading(false);
              this.popupHidden();
            })
            .catch((err) => {
              if (err) this.setLoading(false);
            });
        } else {
          this.setLoading(true);

          let rowKey = 0;
          let payload = {
            DeliveryNote: undefined,
            DeliveryNoteLineNo: undefined,
            ItemCode: this.almondcoDespatchData.data.ItemCode,
            ItemDescription: this.almondcoDespatchData.data.ItemDescription,
            RecordId: "00000000-0000-0000-0000-000000000000",
            AlmondcoWriteDespatchDataDetails: this.localItems.map((item) => {
              return {
                DespatchDate: item.DispatchDate.toSaveDate(),
                PackedOnDate: item.PackedOnDate.toSaveDate(),
                LotNo: item.LotNo,
                PalletNo: item.LotSequenceNo,
                WorkOrderNo: item.WorkOrder,
                CartonWeight: item.CartonWeight,
                CartonQuantity: item.CartonQuantity,
                TotalWeight: item.DespatchWeight,
                PickedWeight: this.dataModel.PickedWeight,
                RecordId: "00000000-0000-0000-0000-000000000000",
                rowKey: ++rowKey,
              };
            }),
          };
          this.almondcoDespatchData.data.AlmondcoWriteDespatchData = payload;

          this.setLoading(false);
          this.popupHidden();
        }
      }
    },
  },
};
</script>

<style lang="scss">
.header-form {
  margin-bottom: 25px;
}
.footer-form {
  margin-top: 25px;
  display: flex;
  justify-content: flex-end;
}

.footer {
  .save-btn {
    margin-right: 25px;
  }
}

.a-des-d-carton-size {
  .dx-texteditor-input-container > input {
    text-align: left;
  }
}
</style>
